const copyrightDate = () => {
  const copyrightYear = document.querySelector('.js-copyright-date');
  const currentYear = new Date().getFullYear();

  copyrightYear.innerHTML = currentYear;
}

copyrightDate();

export default copyrightDate;
